<netfirm-login-card
	[showPrimaryButton]="true"
	[showFirstLink]="false"
	[showSecondaryButton]="false"
	[showOptionDivider]="false"
	primaryButtonText="{{'Netfirm.CiamLogin.SignBackIn' | translate}}"
	(primaryButtonClick)="goToLogin()"
>
	<div slot="body">
		<div class="NetfirmLogin-timeout--container">
			<h1 class="Netfirm-H1Title">{{'Netfirm.CiamLogin.YouHaveBeenSignedOut' | translate}}</h1>
			<p class="NetfirmLogin-paragraph">{{'Netfirm.CiamLogin.SignedOutForInactivity' | translate}}</p>
		</div>
	</div>
</netfirm-login-card>
